import { render } from "./FinalNarrative.vue?vue&type=template&id=f87f64ee&scoped=true"
import script from "./FinalNarrative.vue?vue&type=script&lang=js"
export * from "./FinalNarrative.vue?vue&type=script&lang=js"

import "./FinalNarrative.vue?vue&type=style&index=0&id=f87f64ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f87f64ee"]])

export default __exports__